import PartnersClass from '../../partners/model/Partners';
export default class ProjectPartners {
    constructor(projects) {
        const { id, partner_id } = projects;
        this.id = id;
        this.partners_id = partner_id ? new PartnersClass(partner_id) : undefined;
    }
}
